import { render, staticRenderFns } from "./BoxGroup.vue?vue&type=template&id=dde13bc4&scoped=true"
import script from "./BoxGroup.vue?vue&type=script&lang=js"
export * from "./BoxGroup.vue?vue&type=script&lang=js"
import style0 from "./BoxGroup.vue?vue&type=style&index=0&id=dde13bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde13bc4",
  null
  
)

export default component.exports